import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {BetWinMode} from "@nolimitcity/slot-game/bin/core/gametype/BetWinMode";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {NudgeReelEvent} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeReelEvent";
import {NudgeSpinReelController} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeSpinReelController";
import {Elastic, TimelineLite, TweenLite} from 'gsap';
import {BarbarianFuryGameConfig} from "../../BarbarianFuryGameConfig";
import {BarbarianFuryGameModuleConfig} from "../../BarbarianFuryGameModuleConfig";
import {BarbarianFurySoundConfig} from "../../BarbarianFurySoundConfig";
import {BFGameShaker} from "../../gameshake/BFGameShaker";
import {BFScatterNudgeController} from "../../screens/scatterNudge/BFScatterNudgeController";
import {BarbarianFuryParsedGameData} from "../../server/data/BarbarianFuryParsedGameData";
import {BFNudgeStackedWPView} from "./BFNudgeStackedWPView";

/**
 * Created by Ning Jiang on 11/8/2017.
 */

export class BFNudgeStackedWPController extends WinPresentationController {
    private static readonly NUDGE_STEP_SPEED:number = 0.4;

    private _view:BFNudgeStackedWPView;
    public static _nudgeData:BarbarianFuryParsedGameData | null;
    private _nudgeState:boolean[] = [];
    private _isNudging:boolean = false;
    private _stackedPositions:number[] | undefined;
    private _currentStackedIndexes:number[];
    private _lastTeaseReelId:number;
    private _isFinishCalled:boolean = false;
    private _nudgeSpinStartData:BarbarianFuryParsedGameData | null;
    private _isAborted:Boolean = false;
    private _alreadyNudged:boolean = false;
    private _stackNudgeCounter:number = 1;
    private playsoundReelId:number[][] = [[-1, -1]];
    public static _symwinstates:boolean[][] = [];
    private highestNudgingReel:number[][] = [];
    private tl:TimelineLite | null = new TimelineLite();


    constructor(indexes:[number, number]) {
        super(indexes, {
            name : "BFNudgeStackedWPController",
            betWinMode : BetWinMode.BET_LINE,
            skippable : true
        });

        this._view = new BFNudgeStackedWPView();
        this.initValues();
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, NudgeReelEvent.NUDGE_STEP_COMPLETED, (event:GameEvent) => this.onNudgeStepCompeted(event.params[0]));
        EventHandler.addEventListener(this, NudgeReelEvent.NUDGE_COMPLETED, (event:GameEvent) => this.onNudgeCompleted(event.params[0]));
        EventHandler.addEventListener(this, "reelTeaseCompleted", (event:GameEvent) => this.onTeaseCompleted(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.parseFeatureGameData(event.params[0]));
        EventHandler.addEventListener(this, "removeFrozenAnimations", (event:GameEvent) => this.removeFrozens(event.params[0]));
        //    added this listener to check if win presentation is aborted at any step
        // EventHandler.addEventListener(this, "SET_ABORTED_TRUE", () => {
        // commented this code since we have step by step abort on presnetation now,
        // so no need to handle abort of this presentation from other presenations abort.
        //     this._isAborted = true;
        // });
        // added this listener to set this._isAborted = true on tease abort if there is Respin in next mode
        EventHandler.addEventListener(this, "reelTeaseAbort", () => {
            if(this._gameData!.nextMode.indexOf("RESPIN") !== -1) {
                this._isAborted = true;
            }
        });
        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_SPIN_STARTED, () => this.nudgeOnSpinStart());
        EventHandler.addEventListener(this, NudgeReelEvent.NUDGE_STEP_START, (event:GameEvent) => this.playStackStepSound(event.params[0], event.params[1]));
        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_SPIN_STOPPED, () => this._isFinishCalled = false);  // listening this event to handle finish calling on quickstop
    }

    /**
     * added this function to play stack sound on nudge start
     * @param reelId
     * @param steps
     */
    private playStackStepSound(reelId:number, steps:number):void {
        if(!this._isNudging) {
            return
        }
        let highNo:number = this.highestNudgingReel[0][1];
        this.playsoundReelId[0][0] = this.highestNudgingReel[0][0];
        this.playsoundReelId[0][1] = this.highestNudgingReel[0][1];
        for(let i = 0; i < this.highestNudgingReel.length; i++) {
            if(this.highestNudgingReel[i][1] > highNo) {
                highNo = this.highestNudgingReel[i][1];
                this.playsoundReelId[0][0] = this.highestNudgingReel[i][0];
                this.playsoundReelId[0][1] = this.highestNudgingReel[i][1];
            }
        }
        let pos = this.initNudgePositions(this._nudgeSpinStartData);
        let nudgeUp = pos![reelId] > 0;
        // added this tween to play post tease animation in tease start
        TweenLite.delayedCall(0.1,
            () => BarbarianFuryGameModuleConfig.foregroundAnimation.playPostTeaseAnimation(reelId, nudgeUp)
        );
        // if (this.playsoundReelId[0][0] !== reelId && this.playsoundReelId[0][1] < steps) {
        //     this.playsoundReelId[0][0] = reelId;
        //     this.playsoundReelId[0][1] = steps;
        // }
        if(this.playsoundReelId[0][0] === reelId) {
            SlotGame.sound.playEffect(BarbarianFurySoundConfig.instance.RESPIN_NUDGE + this._stackNudgeCounter);
            this._stackNudgeCounter++;

        }

    }

    /**
     * this function will call every time spins start.
     * function to nudge on spin start
     * if there is respin in next mode and wp is aborted.
     */
    private nudgeOnSpinStart():void {
        if(!this._isAborted) {
            return;
        }
        let pos = this.initNudgePositions(this._nudgeSpinStartData);
        this._nudgeSpinStartData!.initialStackOverlay.forEach((doNudge:boolean, reelId:number) => {
            if(doNudge) {
                const index:number = pos![reelId];
                //if (MathHelper.isInRange(index, 0, 4)) {
                (<NudgeSpinReelController>Reels.getReel(reelId)).nudge(index, 0, Elastic.easeIn.config(0, 0), 0);

                let symbId = (index < 2) ? 3 : 0;
                let sym = Reels.getSymbol(reelId, symbId);
                sym!.changeState({
                    state : BarbarianFuryGameConfig.instance.SYMBOL_STATES.normal,
                    fadeInDuration : 0
                });
            }
        });
        this._isAborted = false;
        this._nudgeSpinStartData = BFNudgeStackedWPController._nudgeData;
    }

    protected parseFeatureGameData(data:BarbarianFuryParsedGameData):void {
        this._alreadyNudged = false;
        BFNudgeStackedWPController._nudgeData = data;
        this._stackedPositions = this.initNudgePositions(BFNudgeStackedWPController._nudgeData);
    }

    protected hasWin():boolean {
        this._nudgeSpinStartData = BFNudgeStackedWPController._nudgeData;   //  keep data till next reel stops
        return BFNudgeStackedWPController._nudgeData!.stackedSpinTease;
    }

    protected startWinPresentation():void {
        this._isFinishCalled = false; // added this._isFinishCalled=false to avoid calling finish twice
        //lastTeaseReelId moved to top (M Sym nudging stuck in random scenarios in Auto Play Bug fixed).
        this._lastTeaseReelId = this.getlastTeasingReelid();
        this._view.teaseReels(BFNudgeStackedWPController._nudgeData);
    }

    // function to get last teasing reel on which there is not stack.
    // to fix #201
    private getlastTeasingReelid():number {
        let initialStackOverlay = [...BFNudgeStackedWPController._nudgeData!.initialStackOverlay];
        let initialStackOverlayInCaseAllReturnsFalse = initialStackOverlay.lastIndexOf(true);
        for(let i = 0; i < initialStackOverlay.length; i++) {
            if(initialStackOverlay[i]) {
                let vt = BFNudgeStackedWPController._nudgeData!.reels[i].slice(1, 5).filter((str:string) => str.indexOf("M") !== -1).length === 4;
                if(vt) {
                    initialStackOverlay[i] = false;
                }
            }
        }
        // to fix #254
        return (initialStackOverlay.lastIndexOf(true) === -1) ? initialStackOverlayInCaseAllReturnsFalse : initialStackOverlay.lastIndexOf(true);
    }

    protected onTeaseCompleted(id?:number):void {
        if(id !== this._lastTeaseReelId) {
            return;
        }
        BarbarianFuryGameModuleConfig.foregroundAnimation.hideAllteaseAnimation(); //  to fix #252
        this._isNudging = true;
        let delay:number = 0;
        BFNudgeStackedWPController._nudgeData!.initialStackOverlay.forEach((doNudge:boolean, reelId:number) => {
            if(doNudge) {
                this.doStackedReelNudge(reelId, false, delay);
            }

        });

    }

    protected stopWinPresentation(isAbort:boolean):void {
        this.highestNudgingReel = [];
        this._stackNudgeCounter = 1;
        let data = BFNudgeStackedWPController._nudgeData;
        if(!isAbort) {
            return;
        } else {
            if(this.tl && this.tl!.isActive()) {
                this.tl!.pause();
                this.tl!.kill();
                this.tl = null;
            }
            BarbarianFuryGameModuleConfig.foregroundAnimation.hideAllpostTeaseAnimation([0, 1, 2, 3, 4]); // added this to fix #240
            // if already nudged is true that means tease is completed no need to send tease abort then
            !this._alreadyNudged && EventHandler.dispatchEvent(new GameEvent("reelTeaseAbort", data!.initialStackOverlay));
            if(data!.stackedSpinTriggered) {
                this._view.playFreezingAnimations(data);
            }
        }
        if(this._isNudging) {
            this._nudgeState.forEach((isNudging:boolean, reelId:number) => {
                if(isNudging) {
                    // Abort don't send complete event so it will not trigger onNudgeCompleted() again.
                    (<NudgeSpinReelController>Reels.getReel(reelId)).abortNudge();
                    this._nudgeState[reelId] = false;
                }
            });
        } else {
            data!.initialStackOverlay.forEach((doNudge:boolean, reelId:number) => {
                if(doNudge) {
                    // !isAbort added to fix #110-1 need to discuss with gaurav
                    // if there is no abort and not aborted at wp only the doStackedReelNudge function will be called
                    (!isAbort && !this._isAborted) && this.doStackedReelNudge(reelId, true, 0);
                }
            });
        }
        this._isNudging = false;
        // todo sounds
        /*if (this._nudgeAborted) {
            // SlotGame.sound.playEffect(WildNudgeSoundConfig.instance.SCATTER_LANDING_2);
        }*/
    }

    protected resetFeature():void {
        this._isNudging = false;
        this.initValues();
    }

    protected initNudgePositions(data:any):number[] {
        let initReelSet = data!.reels;
        let visibleReelSet = [];
        let nudgePos = [];

        for(let i = 0; i < initReelSet.length; i++) {
            let itemArray = initReelSet[i].slice(1, initReelSet[i].length - 1);
            visibleReelSet.push(itemArray);
        }

        for(let i = 0; i < visibleReelSet.length; i++) {
            for(let j = 0; j < visibleReelSet[i].length; j++) {
                if(visibleReelSet[i][j].indexOf("*3") > -1) {
                    nudgePos[i] = 3 - j;
                } else if(visibleReelSet[i][j].indexOf("*0") > -1) {
                    nudgePos[i] = -1 * j;
                }
            }
        }

        for(let i = 0; i < nudgePos.length; i++) {
            if(nudgePos[i] === undefined) {
                nudgePos[i] = 0;
            }
        }

        return nudgePos;
    }

    protected removeFrozens(nudgingReels:boolean[]):void {
        nudgingReels = nudgingReels ? nudgingReels : BFNudgeStackedWPController._nudgeData!.initialStackOverlay;
        let isNudgingReels:boolean[] = nudgingReels ? nudgingReels : BFNudgeStackedWPController._nudgeData!.initialStackOverlay;
        this._view.stopFreezingAnimations(isNudgingReels);
        EventHandler.dispatchEvent(new GameEvent("setStickyWild", false));
    }

    private initValues():void {
        this._isNudging = false;
        this._nudgeState = ArrayHelper.initArrayWithValues<boolean>(5, () => {
            return false;
        });
        this._currentStackedIndexes = ArrayHelper.initArrayWithValues<number>(5, () => {
            return -1
        });
    }

    private doStackedReelNudge(reelId:number, isAbort:boolean, delay:number):void {
        if(!isAbort) {
            this._nudgeState[reelId] = true;
        }
        const index:number = this._stackedPositions![reelId];
        let sym = Reels.getSymbol(reelId, 0);
        //if (MathHelper.isInRange(index, 0, 4)) {
        if(BFNudgeStackedWPController._nudgeData!.stackedSpinTriggered) {
            if(isAbort) {
                (<NudgeSpinReelController>Reels.getReel(reelId)).abortNudge(index);
            } else {
                this._currentStackedIndexes[reelId] = index;
                (<NudgeSpinReelController>Reels.getReel(reelId)).nudge(index, BFNudgeStackedWPController.NUDGE_STEP_SPEED, Elastic.easeIn.config(1.5, 1), delay);
            }
            this.highestNudgingReel.push([reelId, Math.abs(index)]);
            sym!.changeState({
                state : BarbarianFuryGameConfig.instance.SYMBOL_STATES.normal,
                fadeInDuration : 0
            });
            this._alreadyNudged = true;
            return;
        } else {
            if(reelId !== this._lastTeaseReelId) {
                return;
            }
            if(this._gameData!.betWins.length > 0) {
                const symStateArray:number[][] = this._view._changeSymState;
                for(const iterator of symStateArray) {
                    let sym = Reels.getSymbol(iterator[0], iterator[1]);
                    if(BFNudgeStackedWPController._symwinstates.length > 0 && !BFNudgeStackedWPController._symwinstates[iterator[0]][iterator[1]]) {
                        sym!.changeState({
                            state : BarbarianFuryGameConfig.instance.SYMBOL_STATES.noWin,
                            fadeInDuration : 0
                        })
                    }
                }
            }
            //todo tease failure sounds
            //SlotGame.sound.playEffect(WildNudgeSoundConfig.instance.WILD_NUDGE);
            this.finish();
        }
        //}
    }

    /**
     * override this function to resolve winpresentation error in quick fix.
     * @param isAborted
     */
    protected finish(isAborted?:boolean):void {
        if(this._isFinishCalled) {
            return;
        }
        this._isFinishCalled = true;
        super.finish(isAborted);
    }

    private onNudgeStepCompeted(reelId:number):void {
        if(this._nudgeState[reelId]) {
            // todo sounds
            // SlotGame.sound.playEffect(WildNudgeSoundConfig.instance.SCATTER_NUDGE);
            this._currentStackedIndexes[reelId]++;
        }
    }

    private onNudgeCompleted(reelId:number):void {
        //  added this check to call this finish if this.isAborted is true, && finish not already called
        // !BFScatterNudgeController._ScatterScreenStarted added this to fix #180
        if(this._isAborted && !this._isFinishCalled && !BFScatterNudgeController._ScatterScreenStarted) {
            this.finish();
        }
        if(!this._isNudging) {
            return;
        }
        this.tl = new TimelineLite();
        this.playsoundReelId = [[-1, -1]];
        this._nudgeState[reelId] = false;
        this._currentStackedIndexes[reelId] = -1;
        //Logger.logDev(`BFNudgeStackedWPController.onNudgeCompleted(reelId:${reelId}): nudgeState : ${this._nudgeState.toString()}`);
        BarbarianFuryGameModuleConfig.foregroundAnimation.hideAllpostTeaseAnimation([reelId]);
        if(this._nudgeState.indexOf(true) > -1) {
            return;
        } else {
            TweenLite.to(() => {
            }, 0.1, {
                onComplete : () => {
                    EventHandler.dispatchEvent(new GameEvent(BFGameShaker.START_GAME_SHAKING_REEL_AREA));
                }
            });

            TweenLite.to(() => {
            }, 0.5, {
                onComplete : () => {
                    this._view.playFreezingAnimations(BFNudgeStackedWPController._nudgeData);
                }
            });
            this.tl!.add(
                TweenLite.to(() => {
                }, 0.5, {
                    onComplete : () => {
                        this._alreadyNudged && this.finish();
                        this._stackNudgeCounter = 1;
                    }
                })
            )

            return;
        }
    }
}